(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["kp-dispatch-note"] && !Shopify.designMode) return;
  try {
    const bindDispatchNotes = (root = document) => {
    root
      .querySelectorAll('[data-kp-dispatch-note][data-kp-dispatch-kind="ready-kippah"]:not([data-kp-dispatch-bound])')
      .forEach((note) => {
        note.dataset.kpDispatchBound = 'true';
        const scope = note.closest('product-information') || note.closest('[data-section-id]') || document;
        const output = note.querySelector('[data-kp-dispatch-text]');
        const update = () => {
          const selected = Array.from(scope.querySelectorAll('input[type="radio"]:checked')).find((input) => {
            const value = `${input.name || ''} ${input.value || ''} ${input.closest('label')?.textContent || ''}`;
            return /classic|lined/i.test(value);
          });
          const value = `${selected?.value || ''} ${selected?.closest('label')?.textContent || ''}`;
          output.textContent = /classic/i.test(value) ? note.dataset.kpDispatchClassic : note.dataset.kpDispatchOther;
        };

        scope.addEventListener('change', update);
        update();
      });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => bindDispatchNotes(), { once: true });
  } else {
    bindDispatchNotes();
  }

  document.addEventListener('shopify:section:load', (event) => bindDispatchNotes(event.target));
  } catch(e) { console.error(e); }
})();

})();
